import axiosHttp from './axios';
import config from '../../config';
import {authconfig} from '../shared/utils/common';
import { errorOccuredAndLogged_Mixpanel } from '../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE, NETWORK_ISSUE, NETWORK_ERROR, STORE_LIST_API, SINGLE_STORE_DETAILS_API } from '../constants/mixPannelConstants';

export const makeStoreListCall = async (req)=> {
    let configs = authconfig(config.env, 'merchant');
    const url = process.env.MERCHANT_SERVICE_API+`/merchants/${req.payload.merchantId}`;
	try {
		const response = await axiosHttp.get(url, { timeout: 10000, ...configs});
		return response;
	} catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, STORE_LIST_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, STORE_LIST_API, CONNECTIVITY_ISSUE);
		}
        return error;
	}
}

export const makeSingleStoreDetailsCall = async (req)=> {
	let configs = authconfig(config.env, 'merchant');
	const url = process.env.MERCHANT_SERVICE_API+`/merchants/${req.payload.merchantId}/stores/${req.payload.storeUUID}`;

	try {
		const response = await axiosHttp.get(url, configs);
		return response.data;
	} catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, SINGLE_STORE_DETAILS_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, SINGLE_STORE_DETAILS_API, CONNECTIVITY_ISSUE);
		}
        return error;
	}
}